import { render } from "./AwardsCmt.vue?vue&type=template&id=6f397224&scoped=true"
import script from "./AwardsCmt.vue?vue&type=script&lang=js"
export * from "./AwardsCmt.vue?vue&type=script&lang=js"

import "./AwardsCmt.vue?vue&type=style&index=0&id=6f397224&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f397224"]])

export default __exports__